import React from "react"
import PropTypes from "prop-types"
import { fieldPropTypes } from "redux-form"
import Autocomplete from "@material-ui/lab/Autocomplete"
import TextField from "@material-ui/core/TextField"
import FormControl from "@material-ui/core/FormControl"

export default function FieldComboBox({
  type,
  label,
  placeholder,
  input,
  ...custom
}) {
  return (
    <FormControl>
      <Autocomplete
        id={`${input.name}-auto-id`}
        options={custom.options}
        size="small"
        value={input.value}
        renderInput={(params) => (
          <TextField
            {...params}
            {...input}
            id={input.name}
            type={type}
            label={label}
            variant="outlined"
            fullWidth
          />
        )}
        {...custom}
      />
    </FormControl>
  )
}

FieldComboBox.propTypes = {
  ...fieldPropTypes,
  type: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired
}
